import { useBooleanState } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { CalendarIcon } from '@calendly/ui/components/icons'
import { colorTextSecondary } from '@calendly/ui/theme'

import { useFetchUsersCalendarIntegrationsReport } from 'features/reporting'

import { ConnectedCalendarsModal } from './connected_calendars_modal'
import { VIEWS } from './constants'
import { getTileTitle } from './helpers'
import { LoadingTile } from '../../components/loading_tile'
import { Tile } from '../../components/tile'


// i18n-tasks-use t('publisher.admin.dashboard.section.users.card.connected_calendars.title')
// i18n-tasks-use t('publisher.admin.dashboard.section.users.card.connected_calendars.empty_state')
export const ConnectedCalendarsTile = () => {
  const [isModalOpen, openModal, closeModal] = useBooleanState(false)
  const { data: notConnectedUserIntegrationsData, isFetching: isNotConnectedFetching } = useFetchUsersCalendarIntegrationsReport(
    { group_by: 'user', status: VIEWS.notConnected }
  )

  const { data: failedUserIntegrationsData, isFetching: isFailedFetching } = useFetchUsersCalendarIntegrationsReport(
    { group_by: 'user', status: VIEWS.hasErrors }
  )

  if (isNotConnectedFetching || isFailedFetching) return <LoadingTile />

  const notConnectedCount = notConnectedUserIntegrationsData?.count || 0
  const errorCount = failedUserIntegrationsData?.count || 0

  const isEmpty = notConnectedCount === 0 && errorCount === 0
  const title = getTileTitle({ tileType: 'connected_calendars', count: notConnectedCount })
  const error = errorCount > 0 && I18n.t('publisher.admin.dashboard.section.users.connection_errors', { count: errorCount })

  return (
    <>
      <Tile
        componentName="connected-calendars"
        icon={<CalendarIcon color={colorTextSecondary} />}
        name={title}
        error={error}
        rightControls={!isEmpty && (
          <Button onClick={openModal} decoration="outline" responsive={false} size="small">
            {I18n.t('publisher.admin.dashboard.section.users.button.view_connections')}
          </Button>
        )}
      />
      {!isEmpty && (
        <ConnectedCalendarsModal
          isOpen={isModalOpen}
          onClose={closeModal}
          notConnectedCount={notConnectedCount}
          errorCount={errorCount}
        />
      )}
    </>
  )
}
